import { Modal, Form, Input, message } from 'antd'
import useForm from 'shared/hooks/useForm'
import { connect } from 'react-redux'
import { rpc } from 'shared/actions'
import get from 'lodash/get'
import schema from 'schema'
import React from 'react'

import './ClassLinkInitModal.less'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 }
  }
}

const ClassLinkInitModal = ({ onOk, rpc, ...rest }) => {
  const { handleSubmit, getFieldProps, getFieldError, isSubmitting } = useForm({
    onSubmit: async vals => {
      try {
        await rpc('district.classLinkInit', vals)
        message.success('District initialized.')
        return onOk()
      } catch (e) {
        message.error(
          get(
            e,
            'error.message',
            'Oops, something went wrong. Please try again.'
          )
        )
      }
    },
    initialValues: {
      oneRosterAppId: ''
    },
    validationSchema: schema.district.classLinkInit
  })

  return (
    <Modal
      {...rest}
      confirmLoading={isSubmitting}
      onOk={handleSubmit}
      title='Initialize ClassLink District'
    >
      <Form {...formItemLayout}>
        <Form.Item
          {...getFieldError('oneRosterAppId')}
          label='OneRoster App ID'
        >
          <Input
            {...getFieldProps('oneRosterAppId')}
            autoFocus
            placeholder='OneRoster App ID'
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

/** @todo propTypes */

export default connect(null, { rpc })(ClassLinkInitModal)
